import { render, staticRenderFns } from "./Page_Device.vue?vue&type=template&id=65598872"
import script from "./Page_Device.vue?vue&type=script&lang=js"
export * from "./Page_Device.vue?vue&type=script&lang=js"
import style0 from "./Page_Device.vue?vue&type=style&index=0&id=65598872&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports